import React, { useState, useMemo } from 'react';
import UIButtonToolbar from '../navigation/components/UIButtonToolbar';
import './Downtime.scss';
import DetailedDaily from './DetailedDaily';
import DailySummary from './daily-summary/DailySummary';

export interface TabContent {
  id: number;
  name: string;
  active: boolean;
}

const Downtime: React.FC = () => {
  const [activeTab, setActiveTab] = useState<string>('detailed');

  // Make tabButtons reactive to activeTab changes
  const tabButtons: TabContent[] = useMemo(
    () => [
      {
        id: 0,
        name: 'Detailed daily',
        active: activeTab === 'detailed',
      },
      {
        id: 1,
        name: 'Daily summary',
        active: activeTab === 'summary',
      },
    ],
    [activeTab],
  );

  const handleTabChange = (tabId: number) => {
    const tab = tabButtons.find((button) => button.id === tabId);
    if (tab) {
      if (tab.name === 'Detailed daily') {
        setActiveTab('detailed');
      } else if (tab.name === 'Daily summary') {
        setActiveTab('summary');
      }
    }
  };

  return (
    <div
      className={`main-container ${activeTab === 'detailed' ? 'detailed-daily-main-container' : activeTab === 'summary' ? 'daily-summary-main-container' : ''}`}
    >
      <div className='downtime-header-container'>
        <div className='downtime-header-section'>
          <div className='downtime-title-container'>
            <div className='downtime-title'>Downtime</div>
          </div>
        </div>
      </div>

      <div className='downtime-tabs-container'>
        <UIButtonToolbar uiButtons={tabButtons} buttonClicked={handleTabChange} />
      </div>

      <div className='downtime-content'>
        {activeTab === 'detailed' && (
          <div className='detailed-daily-content'>
            <DetailedDaily />
          </div>
        )}
        {activeTab === 'summary' && (
          <div>
            <DailySummary />
          </div>
        )}
      </div>
    </div>
  );
};

export default Downtime;
